export var VoiceCallDirection;
(function (VoiceCallDirection) {
    VoiceCallDirection["Inbound"] = "Inbound";
    VoiceCallDirection["Outbound"] = "Outbound";
})(VoiceCallDirection || (VoiceCallDirection = {}));
//# sourceMappingURL=voice-call.js.map